import React, { useState } from "reactn"
import { Box, Button, Center, Container, HStack, Input, Spinner, Text, VStack, Grid, GridItem } from "@chakra-ui/react"
import { API } from '@aws-amplify/api';
// import { v4 as uuidv4 } from 'uuid';
import AIIngSlider from "./productInfo/aislider";
import AiDesign, { changeColInUri } from "./aidesigner";
//
const generateRepeat = "/image/generateor";
const generateGarment = "/image/garment";
const url = "/image/generateo";


export default function ImageGenerator({ setDesignGUID, globalState, isGarment = true }) {


  console.log("IMAGE GEN IS GARMENT", isGarment)
  console.log("STORE ABC", globalState)

  const { store, updateGlobal } = globalState



  const empty = ["", "", "", ""]

  const { links, scarves, design } = store
  const [initial, setInitial] = useState(true);
  const [error, setError] = useState('');
  const [fetching, setFetching] = useState(false)
  const [fetchingScarf, setFetchingScarf] = useState(false)
  const [scarf, setScarf] = useState({});
  const [text, setText] = useState('')

  const [selected, setSelected] = useState('')
  const prefix = 'Generate a black and white repeatable pattern without a border for a scarf with '

  const [scarfDesign, setScarfDesign] = useState('');

  async function selectDesign(linkData) {
    console.log("SELECT DESIGN", linkData)
    setError('')
    setSelected(linkData.guid)
    setDesignGUID(linkData.guid)
    // console.log("XXXXX", scarves[linkData.guid])
    // console.log("XXXXX1", (isGarment && scarves[linkData.guid].hasOwnProperty('garmentLink1')))
    // console.log("XXXXX2", (!isGarment && scarves[linkData.guid].hasOwnProperty('scarfLink')))
    if (scarves[linkData.guid] && (
      (isGarment && scarves[linkData.guid].hasOwnProperty('garmentLink1')) ||
      (!isGarment && scarves[linkData.guid].hasOwnProperty('scarfLink'))
    )) {
      const scarf = scarves[linkData.guid]
      scarf.colourFront = null
      scarf.colourRear = null
      scarf.colourGarment1 = null
      scarf.colourGarment1 = null
      scarf.colourGarment3 = null
      console.log("GOINHG X1 - SCARF GET CCC STERT")
      // We have the Scarf
      if (!scarf.cols || scarf.cols != undefined
        || scarves.garment1.includes('https')
        || scarves.garment2.includes('https')
        || scarves.garment3.includes('https')
        // || scarves.cols.length != 2
      ) {
        console.log("GOINHG X1 - SCARF GET CCC GO GO ", scarf)
        let cols
        if (!isGarment) {
          cols = await getColours(scarf.scarfLink, 2)
        } else {
          cols = await getColours(scarf.garmentLink1, 2)
        }
        console.log("X1 - COLS", cols)
        const colsToChange = [
          { to: cols[0], from: cols[1] },
          { to: cols[1], from: cols[0] }
        ]
        let newSrcFront
        let newImgSrc
        let newSrcRear
        let newGarmentSrc1
        let newGarmentSrc2
        let newGarmentSrc3
        if (!isGarment) {
          newSrcRear = await changeColInUri(scarf.scarfLink, colsToChange, setError, true, isGarment, false)
          newImgSrc = await changeColInUri(scarf.imageLink, cols, setError, false, isGarment, true)
          newSrcFront = await changeColInUri(scarf.scarfLink, cols, setError, false, isGarment, false)
          scarf.orginalReversed = newSrcRear
        } else {
          console.log("GETTING GARMENTS DATE")
          newGarmentSrc1 = await changeColInUri(scarf.garmentLink1, colsToChange, setError, false, isGarment, false)
          newGarmentSrc2 = await changeColInUri(scarf.garmentLink2, colsToChange, setError, false, isGarment, false)
          newGarmentSrc3 = await changeColInUri(scarf.garmentLink3, colsToChange, setError, false, isGarment, false)
        }

        // console.log("X1 - SCARF GET NEW REAR S", newSrcRear)
        scarf.cols = cols

        scarves[linkData.guid] = scarf
        var globalUpdate = {
          design: {
            guid: linkData.guid
          },
          scarfOrder: {
            prompt: linkData.prompt,
          }
        }
        if (isGarment) {
          globalUpdate.scarfOrder['design'] = scarf.imageLink
          globalUpdate.scarfOrder['garment1'] = newGarmentSrc1
          globalUpdate.scarfOrder['garment2'] = newGarmentSrc2
          globalUpdate.scarfOrder['garment3'] = newGarmentSrc3
        } else {
          globalUpdate.scarfOrder['image'] = newImgSrc
          globalUpdate.scarfOrder['scarfFront'] = newSrcFront
          globalUpdate.scarfOrder['scarfRear'] = newSrcRear
        }
        console.log("UPDATING GOINHG X1 - SCARF GET CCC GO GO", globalUpdate)
        console.log("UPDATEING GLOBAL B", globalUpdate)

        console.log("X1 - SCARF SET", scarf)
        setScarf(scarf)
        setScarfDesign(linkData.guid)

        updateGlobal(globalUpdate)
        // setGlobal({ scarves })
      } else {

        console.log("UPDATEING GLOBAL BB")
        updateGlobal({
          design: {
            guid: linkData.guid
          }
        })
      }
    } else {

      setFetchingScarf(true)
      const data = {
        body: {
          guid: linkData.guid,
          prompt: linkData.prompt,
          image: linkData.link,
          colours: 2,
          vertical: false
        },
        headers: {
          "Content-Type": "application/json"
        }
      }
      API
        .post('api', isGarment ? generateGarment : generateRepeat, data)
        .then(response => {
          console.log("RESPXXX", response)
          try {
            const setColours = async (response, linkData) => {
              let cols
              if (isGarment) {
                cols = await getColours(response.garmentLink1, 2, isGarment)
              } else {
                cols = await getColours(response.scarfLink, 2, isGarment)
              }

              let thisScarf = {
                prompt: response.prompt,
                imageLink: response.imageLink,
                type: response.type,
                isGarment: isGarment
              }

              if (isGarment) {
                thisScarf.garmentLink1 = response.garmentLink1
                thisScarf.garmentLink2 = response.garmentLink2
                thisScarf.garmentLink3 = response.garmentLink3
              } else {
                thisScarf.scarfLink = response.scarfLink
              }

              const scarfData = scarves

              const colsToChange = [
                { to: cols[0], from: cols[1] },
                { to: cols[1], from: cols[0] }
              ]
              console.log("COLS TO CHANGE", colsToChange)

              let newImgSrc
              let newSrcFront
              let newSrcRear
              let newGarmentSrc1
              let newGarmentSrc2
              let newGarmentSrc3

              thisScarf.cols = cols
              if (!isGarment) {
                newImgSrc = await changeColInUri(response.imageLink, cols, setError, false, true)
                newSrcFront = await changeColInUri(response.scarfLink, cols, setError, false, isGarment)
                newSrcRear = await changeColInUri(response.scarfLink, colsToChange, setError, true, isGarment)
                thisScarf.orginalReversed = newSrcRear
              } else {
                newGarmentSrc1 = await changeColInUri(response.garmentLink1, cols, setError, false, isGarment)
                newGarmentSrc2 = await changeColInUri(response.garmentLink2, cols, setError, false, isGarment)
                newGarmentSrc3 = await changeColInUri(response.garmentLink3, cols, setError, false, isGarment)
              }

              scarfData[linkData.guid] = thisScarf

              var scarfOrder = {
                scarfOrder: {
                  prompt: response.prompt,
                }
              }

              if (isGarment) {
                scarfOrder.scarfOrder['design'] = response.imageLink
                scarfOrder.scarfOrder['garment1'] = newGarmentSrc1
                scarfOrder.scarfOrder['garment2'] = newGarmentSrc2
                scarfOrder.scarfOrder['garment3'] = newGarmentSrc3
              } else {
                scarfOrder.scarfOrder['image'] = newImgSrc
                scarfOrder.scarfOrder['scarfFront'] = newSrcFront
                scarfOrder.scarfOrder['scarfRear'] = newSrcRear
              }
              console.log("UPDATEING GLOBAL C", scarfOrder)
              updateGlobal({
                scarves: scarfData,
                scarfOrder: scarfOrder,
                design: {
                  guid: linkData.guid,
                  imageLink: response.imageLink,
                  scarfLink: response.scarfLink,
                  garmentLink1: response.garmentLink1,
                  type: response.type,
                  isGarment: isGarment
                }
              })
              selectDesign(linkData)

            };
            console.log("LINK DATA", linkData)
            console.log("LINK DATA", response)
            setColours(response, linkData)
          } catch (e) {
            console.log("ERR", e)
          }


        }).catch(error => {
          console.log("ERROR", error)
          setError("Failed to create Full Image, Please Try Again")
        }).finally(() => {

          setFetchingScarf(false)
        })
    }

  };





  async function getColours(data, maxColours, isGarment) {
    // create fake image to calculate height / width
    console.log("X2 - SCARF IC GET", data)
    var img = await document.createElement("img");
    img.src = data;
    img.style.visibility = "hidden";
    img.crossOrigin = "Anonymous";
    await img.decode();
    console.log(`X1 - width: ${img.width}, height: ${img.height}`);
    await document.body.appendChild(img);
    console.log("X1 - IMG", img)
    var canvas = await document.createElement("canvas");
    const imageMiltipler = 1
    const scarfWidth = isGarment ? 256 : 80 // TODO TWW
    const scarfHeight = isGarment ? 256 : 998 // 960 
    canvas.width = scarfHeight * imageMiltipler
    canvas.height = scarfWidth * imageMiltipler
    console.log("X2 - CANVAS", canvas.width, canvas.height)
    if (canvas.width > 0 && canvas.height > 0) {
      var ctx = await canvas.getContext("2d");
      await ctx.drawImage(img, 0, 0);

      // remove image
      await img.parentNode.removeChild(img);

      // do actual color replacement
      var imageData = await ctx.getImageData(0, 0, canvas.width, canvas.height);
      var data = imageData.data;

      var r, g, b;
      var imageColors = []
      var previous = []
      for (var x = 0, len = data.length; x < len; x += 4) {
        r = data[x];
        g = data[x + 1];
        b = data[x + 2];
        if (imageColors.length == 0) {
          if ((r != 0 || g != 0 || b != 0)) {
            imageColors.push({ rgb: { r, g, b }, hex: rgbToHex(r, g, b) })
            previous.push(r + g + b)
          }

        } else if (!previous.includes(r + g + b)) {
          if (r != 0 || g != 0 || b != 0) {
            imageColors.push({ rgb: { r, g, b }, hex: rgbToHex(r, g, b) })
            console.log("X2 - SCARF NEW COL", x, r, g, b)
            previous.push(r + g + b)
          }
          if (imageColors.length == 2) {
          }
        }
      }
    }
    // if (isGarment) {
    imageColors.push({ rgb: { r: 0, g: 0, b: 0 }, hex: rgbToHex(0, 0, 0) })
    // }
    console.log("X2 - SCARF IC COL", imageColors)

    return imageColors
  }

  function rgbToHex(r, g, b) {
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
  }


  function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  async function genearteImageFiles() {

    const currentLinks = links
    const newLinks = [...empty, ...currentLinks]
    setFetching(true)
    setError('')
    setInitial(false)
    console.log("XXXX-1")
    updateGlobal({ links: newLinks })
    console.log("XXXX-2")
    const data = {
      body: {
        prompt: text,
        prefix: prefix,
        suffix: '',
        colours: 2
      },
      headers: {
        "Content-Type": "application/json"
      }
    }
    API
      .post('api', url, data)
      .then(response => {
        const { prompt, links } = response
        for (let i = 0; i < links.length; i++) {
          newLinks[i] = {
            guid: links[i].uuid,
            prompt: prompt,
            link: links[i].url
          }
        }
        if (newLinks && newLinks.length > 16) {
          newLinks.length = 16;
        }
        console.log("NEWLINKS", newLinks)
        updateGlobal({ links: newLinks })
      }).catch(error => {
        setError("Failed to create Images, Please Try Again")
        console.log("ERROR", error)
        var newLinks = [...currentLinks]
        try {
          newLinks = newLinks.shift().shift().shift().shift()
        } catch (e) {
          console.log("ERROR", e)
        }
        if (newLinks && newLinks.length > 16) {
          console.log("REDUCING")
          newLinks.length = 16;
        }
        updateGlobal({ links: newLinks })
      }).finally(() => {
        setFetching(false)
      })

  };

  return (
    <>
      <Container width='100%' maxW='100%' padding={0}>
        <VStack width="100%" fontFamily={'Roboto'} align={'baseline'} marginLeft={0} >
          <Box maxW={'800px'} >
            {initial &&
              <Text fontSize={['md', 'md', 'lg', 'lg']} mb={0} mt={0} color={'gray.800'} >
                What would like to see in your scarf?
              </Text>
            }
          </Box>
          <Grid width="100%" templateColumns={['repeat(1, 1fr)', 'repeat(4, 1fr)', 'repeat(4, 1fr)', 'repeat(4, 1fr)']} gap={2}>
            <GridItem width="100%" colSpan={[1, 3, 3, 3]}>
              <Box width='100%' fontSize='xl' mb={0} mt={0} color={'gray.800'}>
                <Input variant={'desigInput'} width="100%"
                  // maxW={'800px'} 
                  textAlign={'center'}

                  placeholder="cats, dogs, flowers, etc."
                  onChange={newText => setText(newText.target.value)}
                  defaultValue={text}
                />
              </Box>
            </GridItem>
            <GridItem width="100%" >
              <Button variant={"voucher"} size={'cart'}
                // width={'228px'} 
                height={'40px'} padding={0}
                onClick={genearteImageFiles}
                isDisabled={!text}
                rightIcon={fetching ? <Spinner size='xs' /> : null}
                id="createPattern">GENERATE</Button>
            </GridItem>
          </Grid>

        </VStack>
        <Box marginLeft={[5, 5, 10, 10]} marginRight={[5, 5, 10, 10]} >
          <AIIngSlider links={links} selected={selected} fetching={fetching} fetchingScarf={fetchingScarf} onClickEvent={selectDesign} />
        </Box>
        <Center>
          <Text color={'brandWhite.800'} mb={2} fontSize={['md', 'md', 'lg', 'lg']} visibility={error ? 'visible' : 'hidden'}>{error}</Text>
        </Center>
        <AiDesign scarf={scarf} fetching={fetchingScarf} globalState={globalState} isGarment={isGarment} />
      </Container>
    </>
  )
}
